module.exports = __webpack_public_path__ + "img/17.54f85c73.png";